import React, { useState, useEffect, useContext } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import DisclaimerPopup from "./components/DisclaimerPopup.jsx";
import ProtectedRoute from "./routes/ProtectedRoute.jsx";
import { AuthProvider, AuthContext } from "./context/AuthContext";

import KnowledgePage from "./pages/KnowledgePage";
import CalculatorPage from "./pages/CalculatorPage.jsx";
import DashboardPage from "./pages/DashboardPage.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import RegisterPage from "./pages/RegisterPage.jsx";
import ForgotPasswordPage from "./pages/ForgotPasswordPage.jsx";
import ResetPasswordPage from "./pages/ResetPasswordPage.jsx";
import ResultPage from "./pages/ResultPage.jsx";
import BenefitPage from "./pages/BenefitPage.jsx";

function AppContent() {
  const { user } = useContext(AuthContext);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const location = useLocation();

  const hideLayout =
    location.pathname === "/forgot-password" ||
    location.pathname.startsWith("/reset-password");

  useEffect(() => {
    if (user) {
      const accepted = localStorage.getItem("jrj_disclaimer_accepted");
      if (!accepted) setShowDisclaimer(true);
    } else {
      setShowDisclaimer(false);
    }
  }, [user]);

  const handleAccept = () => {
    localStorage.setItem("jrj_disclaimer_accepted", "yes");
    setShowDisclaimer(false);
  };

  return (
    <div className="min-h-[100dvh] flex flex-col bg-slate-50 overflow-x-hidden">
      {showDisclaimer && <DisclaimerPopup onAccept={handleAccept} />}

      {!hideLayout && <Navbar />}

      <main
        className={`flex-1 w-full max-w-4xl mx-auto p-6 ${showDisclaimer ? "opacity-30 pointer-events-none" : ""
          }`}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />


          <Route
            path="/knowledge"
            element={
              <ProtectedRoute>
                <KnowledgePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/benefit"
            element={
              <ProtectedRoute>
                <BenefitPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/calculator"
            element={
              <ProtectedRoute>
                <CalculatorPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/result"
            element={
              <ProtectedRoute>
                <ResultPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>

      {!hideLayout && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter
      future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  }}>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}